import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, filter } from 'rxjs';

@Injectable()
export class HttpCancelService {
  private cancelToken = new BehaviorSubject<string | null>(null);

  public cancelPendingRequests(token: string) {
    this.cancelToken.next(token);
  }

  public onCancelPendingRequests(token: string) {
    return this.cancelToken.pipe(
      filter(value => value === token)
    );
  }
}